import { useState, useEffect } from "react";

import PageLoading from "../../components/PageLoading";

import * as API from "../../api/api.js";

const Faq = () => {
  const [faqData, setFaqData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getFaqDatas();
  }, []);

  const getFaqDatas = () => {
    setLoading(true);
    API.getDatas("/faqs")
      .then((res) => {
        setFaqData(res.data.faq);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <section className="faq-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
              <h3>General FAQ for Traffic School</h3>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
              <div className="accordion faq-blog" id="first-faq-blog">
                {!loading &&
                  faqData &&
                  faqData.map((frequently, index) => (
                    <div id="index" key={index} className="accordion-item">
                      <h2 className="accordion-header" id={`heading-${index}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse-${index}`}
                        >
                          {frequently.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse-${index}`}
                        className={`accordion-collapse collapse ${
                          index === 0 ? "show" : ""
                        }`}
                        aria-labelledby={`heading-${index}`}
                        data-bs-parent="#first-faq-blog"
                      >
                        <div className="accordion-body">
                          <p>{frequently.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {loading && (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <PageLoading color={"var(--metro-yellow)"} classes={"justify-content-center"} />
          </div>
        </div>
      )}
    </>
  );
};

export default Faq;
